import { DateTime } from "luxon";
import { plural } from "@/utils/plurals";
import lexicon from "@/utils/lexicon";
import {
  PRICE_FIXED_FROM,
  UNLIMITED_QUANTITY,
} from "@/constants/subscriptionQuantity";

export const SUBSCRIPTION_STATE = {
  trial: "trial",
  trialEnded: "trialEnded",
  waiting: "waiting",
  canceled: "canceled",
  active: "active",
};

export function getSubscriptionState(company, hasPayments) {
  switch (company.subscriptionStatus) {
    case "trial":
      return SUBSCRIPTION_STATE.trial;
    case "trialEnded":
      return SUBSCRIPTION_STATE.trialEnded;
    case "waiting":
      return SUBSCRIPTION_STATE.waiting;
    case "subscribed":
      return !company.wayforpayOrderReference && hasPayments
        ? SUBSCRIPTION_STATE.canceled
        : SUBSCRIPTION_STATE.active;
    default:
      return null;
  }
}

export function getTrialDaysLeft(trialEndDate, now = DateTime.now()) {
  if (!trialEndDate) {
    return 0;
  }

  const days = DateTime.fromISO(trialEndDate).diff(
    now.startOf("day"),
    "days",
  ).days;

  return Math.max(Math.round(days), 0);
}

export function getBillingPeriod(nextChargeDate) {
  if (!nextChargeDate) {
    return null;
  }

  const next = DateTime.fromISO(nextChargeDate).startOf("day");

  return {
    start: next.minus({ months: 1 }).toJSDate(),
    end: next.minus({ days: 1 }).toJSDate(),
  };
}

export function formatAmount(value) {
  const amount = Number(value);

  return Number.isFinite(amount) ? amount.toLocaleString("uk-UA") : value;
}

export function formatDate(value) {
  return value ? new Date(value).toLocaleDateString("uk-UA") : "";
}

export function isActivated(product) {
  return product.type === "hms" || product.type === "spa" || product.isSelected;
}

export function normalizeQuantity(value, options) {
  if (options.some((option) => option.value === value)) {
    return value;
  }

  const hasUnlimited = options.some(
    (option) => option.value === UNLIMITED_QUANTITY,
  );

  return hasUnlimited && value >= PRICE_FIXED_FROM ? UNLIMITED_QUANTITY : value;
}

export function quantityText(value, forms, options = []) {
  const normalized = normalizeQuantity(value, options);
  const label = options.find((option) => option.value === normalized)?.label;

  return label && label !== String(normalized)
    ? `${label} ${forms[2]}`
    : plural(normalized, forms);
}

export function getStaffForms(company) {
  if (company.crmMode === "hotel") {
    return lexicon.room;
  }

  return company.localizationMode === "beauty"
    ? lexicon.master
    : ["обʼєкт", "обʼєкти", "обʼєктів"];
}
